<template>
    <div class="registerbodybox">
        <div class="contents">
            <div class="registerbody-left">
               <div class="registerbody-left-one">
                    <img :src="bannerimg">
               </div>
               <div class="registerbody-left-two">
                    <img :src="imgurl">
               </div>
            </div>
  
            <div class="registerbody">
                <div class="register">
                <div class="registertitle">
                    <p class="registertitlec">填写表单与我们联系</p>
                    <p class="registertitles">带<span>*</span>的部分为必填选项</p>
                </div>
                <div class="link-top"></div>
                
                <user-contact-us></user-contact-us>  

                </div>
            </div>
        </div>   
    </div>

</template>

<script>
import UserContactUs from '../../components/user/UserContactUs.vue'


export default {
  data(){
    return {
        bannerimg:"",
        imgurl:"",
    }
  },
  metaInfo() {
    return {
      title: "Movibot官网_工业机器人上下游供应链",
      meta: [
        {
          name: "keywords",
          content:
            "工业机器人_工业机器人上下游供应链_工业机器人品牌_工业自动化设备_行业解决方案",
        },
        {
          name: "description",
          content:
            "Movibot汇聚中国工业机器人上下游供应链优质工业机器人品牌,为工业机器人,智能家庭及商业应用,仓储物流,食品行业,医药行业,汽车行业,机械设备制造,电子行业提供工业自动化设备和行业解决方案",
        },
      ],
    };
  },
  components: { UserContactUs},
  mounted(){
      this.bannerimg = localStorage.getItem("bannerimg");
      this.imgurl = localStorage.getItem("imgurl");
    }

}
</script>

<style scoped>
    .registerbodybox{
        overflow: hidden;
         background-color: #f3f5f7;
    }
    .registerbody{
        background-color: #f3f5f7;
        width:800px;
        float: right;
        overflow: hidden;
    }
    .registerbody-left{
        width:210px;
        overflow: hidden;
        float: left;
        margin-left: 95px;
    }
    .registerbody-left .register{
         width: 210px;
    }
    .register{
        width: 800px;
        margin: 0 auto;
        margin-top: 70px;
    }
    .register .registertitle .registertitlec{
        font-size: 36px;
        color: #2655ae;
        margin-bottom: 13px;
    }
    .register .registertitle .registertitles{
        font-size: 18px;
        color: #999999;
        margin-bottom: 20px;
    }
    .register .registertitle .registertitles span{
        color: #ff1111;
       
    }
     .link-top {
            width: 99%;
            height: 1px;
            border-top: solid #f7d385 1px;
            margin: 0 auto;
            margin-bottom: 25px;
     }
     .registerbody-left-one{
        margin-top: 70px;
        border-radius: 10px;
        background-color: #fff;
     }
     .registerbody-left-two{
        margin-top: 20px;
     }
     .registerbody-left-one,.registerbody-left-two{
        width: 100%;
     }
     .registerbody-left-one img,.registerbody-left-two img{
        width: 100%;
     }

</style>


// WEBPACK FOOTER //
// src/views/help/cooperationgoods.vue